if (!customElements.get('product-modal')) {
  const ProductModalBase = customElements.get('modal-dialog') || window.ModalDialog || HTMLElement;

  customElements.define(
    'product-modal',
    class ProductModal extends ProductModalBase {
      constructor() {
        super();
      }

      hide() {
        if (typeof super.hide === 'function') {
          super.hide();
        } else {
          this.removeAttribute('open');
        }
      }

      show(opener) {
        if (typeof super.show === 'function') {
          super.show(opener);
        } else {
          this.openedBy = opener;
          this.setAttribute('open', '');
        }
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
